import React, { useMemo } from "react";
import { useDictionary } from "hooks";
import Helper from "./helpers";

import { API_HAZARD_SAFETY_PROTOCOLS } from "globals/constants";

import IntegrationComponent from "components/flowable/Integration/IntegrationComponent";

const HazardSafetySearch = props => {
	const { onEvent, onChange, config } = props;

	const dictionary = useDictionary("hazardSafetySearch");

	const hazardSafetyDictionary = useMemo(() => {
		return {
			headline: dictionary?.headline || "Link to Hazard Safety",
			description: dictionary?.description
		}
	}, [ dictionary ]);

	const cardKeys = useMemo(() => {
		return {
			protocolNumber: dictionary?.protocolNumber ?? "Protocol #",
			title:  dictionary?.title ?? "Title",
			approveDate:  dictionary?.approvalDate ?? "Approval Date",
			expirationDate:  dictionary?.expirationDate ?? "Expiration Date",
			primaryInvestigatorName:  dictionary?.principleInvestigator ?? "PI",
			protocolStatus:  dictionary?.status ?? "Status"
		}
	}, [ dictionary ]);

	return (
		<IntegrationComponent
			helper={Helper}
			url={API_HAZARD_SAFETY_PROTOCOLS}
			cardKeys={cardKeys}
			dictionary={hazardSafetyDictionary}
			config={config}
			onChange={onChange}
			onEvent={onEvent}
		/>
	);
};

export default HazardSafetySearch;
